import { Point } from '@models/connector';

export function calculateEllipsePoints(rectangle) {
    const xAxis = Number(rectangle.getAttribute('rx'));
    const yAxis = Number(rectangle.getAttribute('ry'));
    const initialX = Number(rectangle.getAttribute('cx'));
    const initialY = Number(rectangle.getAttribute('cy'));
    const transformString = rectangle.getAttribute('transform');
    const numberOfPoints = 12;

    let rotation: { angle: number; cx: number; cy: number } | null = null;
    if (transformString) {
        const rotateMatch = transformString.match(
            /rotate\(\s*([-\d.]+)(?:deg)?\s*[,\s]\s*([-\d.]+)\s*[,\s]\s*([-\d.]+)\s*\)/
        );
        if (rotateMatch) {
            rotation = {
                angle: parseFloat(rotateMatch[1]),
                cx: parseFloat(rotateMatch[2]),
                cy: parseFloat(rotateMatch[3]),
            };
        }
    }

    function applyRotation(point: Point): Point {
        if (!rotation) return point;
        const rad = (rotation.angle * Math.PI) / 180;
        const cos = Math.cos(rad);
        const sin = Math.sin(rad);
        const dx = point.x - rotation.cx;
        const dy = point.y - rotation.cy;
        return {
            x: rotation.cx + dx * cos - dy * sin,
            y: rotation.cy + dx * sin + dy * cos,
        };
    }

    const points = [];
    const deltaTheta = (2 * Math.PI) / numberOfPoints;

    for (let i = 0; i < numberOfPoints; i++) {
        const theta = i * deltaTheta;
        const x = initialX + xAxis * Math.cos(theta);
        const y = initialY + yAxis * Math.sin(theta);
        points.push(applyRotation({ x, y }));
    }

    return points;
}
